import React from "react";
import _ from "lodash";
import { Button, Card, Col, ProgressBar, Row } from "react-bootstrap";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
function PackageCardSkeleton() {
  const defaultDataImages = [1, 2, 3, 4];
  return (
    <SkeletonTheme>
      <Card className="rounded-4 h-100">
        <Card.Header className="bg-white border-bottom-0 text-center fw-bold rounded-4 px-2">
          <Skeleton height="15px"></Skeleton>
          <div className="border-bottom mt-2"></div>
        </Card.Header>
        <Card.Body className="pt-0 px-2 pb-2">
          <Skeleton height="15px"></Skeleton>
          <div className="d-flex aling-items-center justify-content-center rounded-image pt-3">
            {defaultDataImages.map((defaultDataImages, index) => (
              <span className="ms-1" key={index}>
                <div
                  style={{
                    width: 60,
                    height: 60,
                    position: "relative",
                    marginRight: "-10px",
                  }}
                >
                  <Skeleton
                    circle={true}
                    width={60}
                    height={60}
                    style={{ border: "2px solid white" }}
                  />
                </div>
              </span>
            ))}
          </div>

          <div className=" pt-2">
            <Skeleton height="15px"></Skeleton>
          </div>
        </Card.Body>
        <Card.Footer className="bg-white rounded-4 rounded-top-0 border-top-0">
          <Row className="border-top pt-3 pb-0">
            <Col className="text-center">
              <div className="">
                <Skeleton height="15px"></Skeleton>
              </div>
              <div className="fs-101 fw-bold">
                <Skeleton height="15px"></Skeleton>
              </div>
            </Col>
            <Col xs="auto" className="ps-0 pe-2 text-end my-auto">
              <Skeleton
                height="40px"
                width="136px"
                className=" rounded-2"
              ></Skeleton>
            </Col>
            <Col xs="12" className="py-3">
              {/* <ProgressBar
                variant="danger"
                now={Math.ceil((data.soldOut * 100) / data.capacity)}
              /> */}
            </Col>
            <Col xs="auto" className="fs-075 pb-2">
              {/* {Math.ceil((data.soldOut * 100) / data.capacity)} % فروش رفته */}
            </Col>
            <Col xs className="pb-2">
              <div className="d-flex ltr text-danger fs-075 reverse-timer">
                <div className="timer-number">
                  <Skeleton height="15px"></Skeleton>
                </div>
                <div className="px-1">:</div>
                <div className="timer-number">
                  <Skeleton height="15px"></Skeleton>
                </div>
                <div className="px-1">:</div>

                <div className="timer-number">
                  <Skeleton height="15px"></Skeleton>
                </div>
                <div className="px-1">:</div>
                <div className="timer-number">
                  <Skeleton height="15px"></Skeleton>
                </div>
              </div>
            </Col>
          </Row>
        </Card.Footer>
      </Card>
    </SkeletonTheme>
  );
}
export default PackageCardSkeleton;
